var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBusinessInterruption = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49,37.5L31.3,5c-2.8-4.8-9.8-4.8-12.6,0L1,37.5c-2.9,4.9,0.6,11.1,6.3,11.1h35.3C48.3,48.6,51.9,42.4,49,37.5z M25,42.7c-1.6,0-2.9-1.3-2.9-2.9c0-1.6,1.3-2.9,2.9-2.9s2.9,1.3,2.9,2.9C27.9,41.4,26.6,42.7,25,42.7z M27.9,31c0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9V16.3c0-1.6,1.3-2.9,2.9-2.9s2.9,1.3,2.9,2.9V31z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBusinessInterruption, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/business-interruption.67b7859e.svg";
export { ForwardRef as ReactComponent };